
import React from 'react';
import { Breadcrumb, Layout, Menu, theme } from 'antd';
import StatusPage from './StatusPage';
import CreateIncident from './CreateIncident';
import History from './History';
const { Header, Content, Footer } = Layout;

const AppStatus = () => {
  const [toggle, setToggle] = React.useState(0);
const jsessionid = localStorage.getItem("JSESSIONID");
  return (
    <Layout>
      <Header
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 1,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          background: "#ffffff",
          height: "80px",
          borderBottom:'1px solid rgb(234, 236, 240)'
        }}
      >
        <div style={{display:'flex', justifyContent:"space-between",alignItems:'center', width:'100%'}}>
            <div style={{width:'135px',height:'70px'}}>
                <img src={`data:image/png;base64,${process.env.REACT_APP_MY_SITE_LOGO}`} style={{ width: "100%",height:'100%', objectFit:'contain'}} />
            </div>
            {toggle ===0 && <div>
                <span style={{color:'#5c667b',cursor:'pointer',fontWeight:'400',fontSize:'20px', borderBottom:'2px solid #5c667b',paddingBottom:'10px', paddingInline:'10px'}}>Dashboard</span>
                &nbsp;&nbsp;&nbsp;
                {/* <span style={{color:'#5c667b',fontWeight:'300',cursor:'pointer',fontSize:'20px',paddingBottom:'10px', paddingInline:'10px'}} onClick={()=>setToggle(2)}>History</span> */}
                {jsessionid && <span style={{color:'#5c667b',marginLeft:'20px',fontWeight:'300',cursor:'pointer',fontSize:'20px',paddingBottom:'10px', paddingInline:'10px'}} onClick={()=>setToggle(1)}>Create Incident</span>}
            </div>}
            {toggle ===1 && <div>
                <span style={{color:'#5c667b',fontWeight:'300',cursor:'pointer',fontSize:'20px',paddingBottom:'10px', paddingInline:'10px'}} onClick={()=>setToggle(0)} >Dashboard</span>
                &nbsp;&nbsp;&nbsp;
                {/* <span style={{color:'#5c667b',fontWeight:'300',cursor:'pointer',fontSize:'20px',paddingBottom:'10px', paddingInline:'10px'}} onClick={()=>setToggle(2)} >History</span> */}
                &nbsp;&nbsp;&nbsp;
                <span style={{color:'#5c667b',cursor:'pointer',fontWeight:'400',fontSize:'20px', borderBottom:'2px solid #5c667b',paddingBottom:'10px', paddingInline:'10px'}} >Create Incident</span>
            </div>}
            {toggle ===2 && <div>
                <span style={{color:'#5c667b',cursor:'pointer',fontWeight:'300',fontSize:'20px',paddingBottom:'10px', paddingInline:'10px'}} onClick={()=>setToggle(0)}>Dashboard</span>
                &nbsp;&nbsp;&nbsp;
                <span style={{color:'#5c667b',fontWeight:'400',cursor:'pointer',fontSize:'20px',paddingBottom:'10px', paddingInline:'10px',borderBottom:'2px solid #5c667b'}} >History</span>
                {jsessionid && <span style={{color:'#5c667b',marginLeft:'20px',fontWeight:'300',cursor:'pointer',fontSize:'20px',paddingBottom:'10px', paddingInline:'10px'}} onClick={()=>setToggle(1)}>Create Incident</span>}
            </div>}
        </div>
      </Header>
      <Content style={{ background:'#fcfcfd',height: '75vh', margin:'auto', width:'95%',marginBlock:'5vh',padding:'24px',overflowY:'auto' }}>
       {toggle===0 && <StatusPage/>}
        {toggle===1 && <CreateIncident/>}
        {/* {toggle===2 && <History/>} */}
      </Content>
      <Footer style={{ justifyContent: 'center',display:'flex', alignItems:'center', height:'50px', background:'#ffffff',borderTop:'1px solid rgb(234, 236, 240)', fontSize:'20px', fontWeight:'400', lineHeight:'22px', color:'#acb6c6' }}>
        <img src={require('../../Images/vizerto_icon.jpg')} style={{ width: "24px",height:'24px'}} />&nbsp;Vizerto Copyright 2025-26
      </Footer>
    </Layout>
  );
};
export default AppStatus;
